import React from 'react';
import { Group, IconButton } from '@economic/taco';

import { t } from '@lingui/macro';
import { SourceComponent } from '~/types';
import FilterInput from '../../../shared/components/FilterInput';

interface FiltersProps {
    compact: boolean;
    filter: string;
    onFilter: (filter: string) => void;
    exporter: {
        open: () => Window | null;
    };
    sourceComponent?: SourceComponent;
}

const Filters = ({ exporter, compact, filter, onFilter, sourceComponent }: FiltersProps) => {
    const handlePrint = () => window.print();
    const handleExportProductGroups = () => {
        exporter.open();
    };

    return (
        <Group>
            {!compact && (
                <>
                    <IconButton
                        aria-label={t`Export to excel`}
                        tooltip={t`Export to excel`}
                        icon="export-to-excel"
                        onClick={handleExportProductGroups}
                    />
                    <IconButton aria-label={t`Print`} tooltip={t`Print`} icon="print" onClick={handlePrint} />
                </>
            )}
            <FilterInput filter={filter} onFilter={onFilter} sourceComponent={sourceComponent} />
        </Group>
    );
};

export default Filters;
